import {SuccessfulApiResponse} from '@eryxcoop/appyx-comm';

export default class GetAllowancesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [
                {
                    concept: 'NC POR ACUERDO COMERCIAL',
                    valid_from: '2026-01-01',
                    valid_to: '2026-12-31',
                    subject: {kind: 'CUSTOMER', business_name: 'Dunder Mifflin'},
                    beneficiary: {kind: 'CUSTOMER', business_name: 'Dunder Mifflin'},
                    subject_is_the_beneficiary: true,
                    resolution: {
                        kind: 'CREDIT_NOTE_REFUND_ON_ARTICLE',
                        percentage: '10',
                        article: {code: '1234', name: 'Pan de molde'},
                    },
                },
                {
                    concept: 'NC POR ACUERDO COMERCIAL',
                    valid_from: '2026-01-01',
                    valid_to: '2026-12-31',
                    subject: {kind: 'CUSTOMER', business_name: 'Dunder Mifflin'},
                    beneficiary: {kind: 'CUSTOMER', business_name: 'Dunder Mifflin'},
                    subject_is_the_beneficiary: true,
                    resolution: {
                        kind: 'CREDIT_NOTE_REFUND_ON_ORDER_TOTAL',
                        percentage: '5',
                    },
                },
            ],
            errors: [],
        };
    }

    allowances() {
        return this.content().map((allowance) => this._adaptAllowance(allowance));
    }

    _adaptAllowance(allowance) {
        return {
            concept: allowance.concept,
            validFrom: allowance.valid_from,
            validTo: allowance.valid_to,
            subject: this._adaptAllowanceSubject(allowance.subject),
            beneficiary: this._adaptAllowanceSubject(allowance.beneficiary),
            resolution: this._adaptAllowanceResolution(allowance.resolution),
        };
    }

    _adaptAllowanceSubject(subject) {
        return {kind: subject.kind, businessName: subject.business_name};
    }

    _adaptAllowanceResolution(resolution) {
        return {
            kind: resolution.kind,
            percentage: resolution.percentage,
            article: resolution.article ? {code: resolution.article.code, name: resolution.article.name} : null,
        };
    }
}
